import { PopperContent } from '@/components/poppers/PopperContent';

export function CharitableEntityDonors() {
  return (
    <PopperContent
      body={'The individual(s) that funded this charitable entity.'}
    />
  );
}
